import React from 'react'
import BrandPanelWave from '@Images/brand-panel-wave.svg'
import ChecksubLogo from '@Images/cs_logo_white.png'

import './BrandPanel.scss'

const BrandPanel: React.FC = () => (
  <div className="BrandPanel">
    <div className="BrandPanel__logo">
      <img
        src={ChecksubLogo}
        className="BrandPanel__logo"
      />
    </div>
    <div className="BrandPanel__quote-section">
      <blockquote className="BrandPanel__quote-text">
        &ldquo;I create 10x more content in half the time.&rdquo;
      </blockquote>
      <div className="BrandPanel__author">
        <div className="BrandPanel__author-avatar">SM</div>
        <div className="BrandPanel__author-info">
          <span className="BrandPanel__author-name">Sarah Mitchell</span>
          <span className="BrandPanel__author-role">Head of Content, ScaleUp Inc.</span>
        </div>
      </div>
    </div>
    <div className="BrandPanel__footer">Trusted by 10,000+ teams worldwide</div>
    <div className="BrandPanel__wave">
      <BrandPanelWave />
    </div>
  </div>
)

export default BrandPanel
